import React, { useState, useContext, useEffect, Suspense } from 'react';
import { AppContext, useAppContext, SET_BED_CONFIG } from '../context/AppContext';
import SelectedPlantInfo from '../components/SelectedPlantInfo';
import gardenBedLayouts from '../data/gardenBedLayouts.json';

export const componentMap = {
	1: React.lazy(() => import('../components/garden-beds/OneTwelveEnglish')),
	2: React.lazy(() => import('../components/garden-beds/OneTwelveFormal')),
	3: React.lazy(() => import('../components/garden-beds/OneTwelveTropical')),
	4: React.lazy(() => import('../components/garden-beds/OneTwelveWaterWise')),
	5: React.lazy(() => import('../components/garden-beds/OneFifteenEnglish')),
	6: React.lazy(() => import('../components/garden-beds/OneFifteenFormal')),
	7: React.lazy(() => import('../components/garden-beds/OneFifteenTropical')),
	8: React.lazy(() => import('../components/garden-beds/OneFifteenWaterWise')),
	9: React.lazy(() => import('../components/garden-beds/OneEighteenEnglish')),
	10: React.lazy(() => import('../components/garden-beds/OneEighteenFormal')),
	11: React.lazy(() => import('../components/garden-beds/OneEighteenTropical')),
	12: React.lazy(() => import('../components/garden-beds/OneEighteenWaterWise')),
	13: React.lazy(() => import('../components/garden-beds/TwoTwelveEnglish')),
	14: React.lazy(() => import('../components/garden-beds/TwoTwelveFormal')),
	15: React.lazy(() => import('../components/garden-beds/TwoTwelveTropical')),
	16: React.lazy(() => import('../components/garden-beds/TwoTwelveWaterWise')),
	17: React.lazy(() => import('../components/garden-beds/TwoFifteenEnglish')),
	18: React.lazy(() => import('../components/garden-beds/TwoFifteenFormal')),
	19: React.lazy(() => import('../components/garden-beds/TwoFifteenTropical')),
	20: React.lazy(() => import('../components/garden-beds/TwoFifteenWaterWise')),
	21: React.lazy(() => import('../components/garden-beds/TwoEighteenEnglish')),
	22: React.lazy(() => import('../components/garden-beds/TwoEighteenFormal')),
	23: React.lazy(() => import('../components/garden-beds/TwoEighteenTropical')),
	24: React.lazy(() => import('../components/garden-beds/TwoEighteenWaterWise')),
	25: React.lazy(() => import('../components/garden-beds/ThreeTwelveEnglish')),
	26: React.lazy(() => import('../components/garden-beds/ThreeTwelveFormal')),
	27: React.lazy(() => import('../components/garden-beds/ThreeTwelveTropical')),
	28: React.lazy(() => import('../components/garden-beds/ThreeTwelveWaterWise')),
	29: React.lazy(() => import('../components/garden-beds/ThreeFifteenEnglish')),
	30: React.lazy(() => import('../components/garden-beds/ThreeFifteenFormal')),
	31: React.lazy(() => import('../components/garden-beds/ThreeFifteenTropical')),
	32: React.lazy(() => import('../components/garden-beds/ThreeFifteenWaterWise')),
	33: React.lazy(() => import('../components/garden-beds/ThreeEighteenEnglish')),
	34: React.lazy(() => import('../components/garden-beds/ThreeEighteenFormal')),
	35: React.lazy(() => import('../components/garden-beds/ThreeEighteenTropical')),
	36: React.lazy(() => import('../components/garden-beds/ThreeEighteenWaterWise')),
	37: React.lazy(() => import('../components/garden-beds/FourTwelveEnglish')),
	38: React.lazy(() => import('../components/garden-beds/FourTwelveFormal')),
	39: React.lazy(() => import('../components/garden-beds/FourTwelveTropical')),
	40: React.lazy(() => import('../components/garden-beds/FourTwelveWaterWise')),
	41: React.lazy(() => import('../components/garden-beds/FourFifteenEnglish')),
	42: React.lazy(() => import('../components/garden-beds/FourFifteenFormal')),
	43: React.lazy(() => import('../components/garden-beds/FourFifteenTropical')),
	44: React.lazy(() => import('../components/garden-beds/FourFifteenWaterWise')),
	45: React.lazy(() => import('../components/garden-beds/FourEighteenEnglish')),
	46: React.lazy(() => import('../components/garden-beds/FourEighteenFormal')),
	47: React.lazy(() => import('../components/garden-beds/FourEighteenTropical')),
	48: React.lazy(() => import('../components/garden-beds/FourEighteenWaterWise')),
	49: React.lazy(() => import('../components/garden-beds/FiveTwelveEnglish')),
	50: React.lazy(() => import('../components/garden-beds/FiveTwelveFormal')),
	51: React.lazy(() => import('../components/garden-beds/FiveTwelveTropical')),
	52: React.lazy(() => import('../components/garden-beds/FiveTwelveWaterWise')),
	53: React.lazy(() => import('../components/garden-beds/FiveFifteenEnglish')),
	54: React.lazy(() => import('../components/garden-beds/FiveFifteenFormal')),
	55: React.lazy(() => import('../components/garden-beds/FiveFifteenTropical')),
	56: React.lazy(() => import('../components/garden-beds/FiveFifteenWaterWise')),
	57: React.lazy(() => import('../components/garden-beds/FiveEighteenEnglish')),
	58: React.lazy(() => import('../components/garden-beds/FiveEighteenFormal')),
	59: React.lazy(() => import('../components/garden-beds/FiveEighteenTropical')),
	60: React.lazy(() => import('../components/garden-beds/FiveEighteenWaterWise')),
};

const ChoosePlantSideWindow = ({ onCategoryChange, selectedPlantData }) => {
	const [currentPlantCategory, setCurrentPlantCategory] = useState(null);
	const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
	const { state } = useAppContext();
	const { bedConfig, chosenPlants } = state.currentDesign || {};
	
	const matchingGardenBed = bedConfig ? gardenBedLayouts.find((layout) => layout.id === bedConfig) : null;
	const plantCategoriesList = matchingGardenBed ? matchingGardenBed.plants.map((plant) => plant.category) : [];

	// Find and create category list associated with the filtered garden bed
	useEffect(() => {
		if (plantCategoriesList.length > 0) {
			setCurrentPlantCategory(plantCategoriesList[currentCategoryIndex]);
			onCategoryChange(plantCategoriesList[currentCategoryIndex]);
		}
	}, [plantCategoriesList, currentCategoryIndex, onCategoryChange]);

	// Category navigation buttons
	const goToNextCategory = () => {
		setCurrentCategoryIndex((prevIndex) =>
			prevIndex < plantCategoriesList.length - 1 ? prevIndex + 1 : prevIndex
		);
	};
	const goToPreviousCategory = () => {
		setCurrentCategoryIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
	};

	const SelectedGardenBed = componentMap[bedConfig] || null;

	return (
		<div className='right-side-window-container'>
			{matchingGardenBed ? (
				<div className='filtered-garden-bed-container'>
					{SelectedGardenBed ? (
						<Suspense fallback={<div>Loading garden bed layout...</div>}>
							<SelectedGardenBed currentPlantCategory={currentPlantCategory} />
						</Suspense>
					) : (
						<p>No garden bed layout found for the selected filters</p>
					)}
				</div>
			) : (
				<p>No matching garden bed layout found.</p>
			)}
			<div className='plant-category-buttons-container'>
				<button
					className='plant-category-buttons'
					onClick={goToPreviousCategory}
					disabled={currentCategoryIndex === 0}>
					Previous
				</button>
				<h2>{currentPlantCategory}</h2>
				<button
					className='plant-category-buttons'
					onClick={goToNextCategory}
					disabled={currentCategoryIndex === plantCategoriesList.length - 1}>
					Next
				</button>
			</div>
      {state.user.hasActiveSubscription && (
        <SelectedPlantInfo selectedPlantData={selectedPlantData} />
      )}
		</div>
	);
};

export default ChoosePlantSideWindow;
